import axios from 'axios';
import * as auth from './auth';

axios.options.xhr = {
  withCredentials: true,
};

// const { VUE_APP_ENDPOINT, VUE_APP_ENDPOINT_TEST } = process.env;
const { VUE_APP_ENDPOINT, VUE_APP_API_KEY } = process.env;

const handleError = (error) => {
  console.log(error.response); // eslint-disable-line no-console
  if (!error.response || !error.response.status) {
    return error;
  }
  return error.response;
};

/**
 * Tokens last for one hour
 */
let tokenAcquiredTime = 0;

let refreshing = false;

const getAuthenticatedHeaders = async () => {
  while (refreshing) await new Promise((resolve) => setTimeout(resolve, 20)); // eslint-disable-line no-await-in-loop

  if (!auth.data.accessToken || (new Date().getTime() - 3500000) > tokenAcquiredTime) {
    refreshing = true;
    const tokenRequest = {
      scopes: [process.env.VUE_APP_MSAL_SCOPE],
      account: auth.data.user,
    };
    try {
      await auth.waitForInteraction();
      const tokenResponse = await auth.acquireTokenSilent(tokenRequest);
      auth.data.accessToken = tokenResponse.accessToken;
      if (tokenResponse.account) auth.data.user = tokenResponse.account;
      if (tokenResponse.idTokenClaims) auth.data.claims = tokenResponse.idTokenClaims;
      tokenAcquiredTime = new Date().getTime();
    } catch (error) {
      auth.acquireTokenRedirect(tokenRequest);
    }
    refreshing = false;
  }
  return {
    Authorization: `Bearer ${auth.data.accessToken}`,
    'x-ms-client-principal-id': auth.data.claims.oid,
  };
};

/** --------------------
 *
 *    Helper functions
 *
 * --------------------- */
// TODO Failing because not authenticated use long ID for bearer token
// ! GET
const getRequest = async (url, authenticated = true) => {
  let headers;
  if (authenticated) {
    headers = await getAuthenticatedHeaders();
  } else {
    //! Else statement added
    headers = {
      Authorization: `Bearer ${(Math.random() + 1).toString(36).substring(2)}`,
    };
  }
  try {
    const response = await axios
      .get(`${VUE_APP_ENDPOINT}${url}`, {
        headers,
      });
    return response.data;
  } catch (e) {
    console.error(e.response.data);
    return handleError(e);
  }
};
//! DELETE
const deleteRequest = async (url, authenticated = true) => {
  let headers;
  if (authenticated) {
    headers = await getAuthenticatedHeaders();
  }
  try {
    const response = await axios
      .delete(`${VUE_APP_ENDPOINT}${url}`, {
        headers,
      });
    return response;
  } catch (e) {
    return handleError(e);
  }
};
//! POST
const postRequest = async (url, body, authenticated = true) => {
  let headers;
  if (authenticated) {
    headers = await getAuthenticatedHeaders();
  }
  try {
    const response = await axios
      .post(`${VUE_APP_ENDPOINT}${url}`, body, {
        headers,
      });
    return response;
  } catch (e) {
    return handleError(e);
  }
};

/**
 * Object specific methods
 */

// users
//! USERS
// const getUser = async (userId) => getRequest(`/user/${encodeURIComponent(userId)}`);
const getUsers = async () => getRequest(`/user/list/all?code=${VUE_APP_API_KEY}`);
const getMyUser = async () => getRequest(`/user?code=${VUE_APP_API_KEY}`);

//! SITES
const getSites = async () => getRequest(`/site/list/all?code=${VUE_APP_API_KEY}`);
const getActiveSites = async () => getRequest(`/site/list/active?code=${VUE_APP_API_KEY}`);
const getSite = async (siteId) => getRequest(`/site/${encodeURIComponent(siteId)}?code=${VUE_APP_API_KEY}`);
const deleteSite = async (siteId) => deleteRequest(`/site/${encodeURIComponent(siteId)}?code=${VUE_APP_API_KEY}`);
const activateSite = async (siteId) => postRequest(`/site/${encodeURIComponent(siteId)}/activate?code=${VUE_APP_API_KEY}`, {});
const updateSite = async (site) => postRequest(`/site/${encodeURIComponent(site.id)}?code=${VUE_APP_API_KEY}`, site);
const addSite = async (site) => postRequest(`/site?code=${VUE_APP_API_KEY}`, site);

//! SIGN IN / OUT
const getSignIns = async (siteId, start = null, end = null) => getRequest(`/site/${encodeURIComponent(siteId)}/signed-in?start=${start || ''}&end=${end || ''}&code=${VUE_APP_API_KEY}`);
const getPublicSignIns = async (siteId, siteLondId, start = null, end = null) => getRequest(`/public/site/${encodeURIComponent(siteId)}/${encodeURIComponent(siteLondId)}/signed-in?start=${start || ''}&end=${end || ''}&code=${VUE_APP_API_KEY}`, false);
const signIn = async (siteId, responses, latLng) => postRequest(`/site/${encodeURIComponent(siteId)}/signin?code=${VUE_APP_API_KEY}`, {
  responses, latLng,
});
const signOut = async (siteId, latLng) => postRequest(`/site/${encodeURIComponent(siteId)}/signout?code=${VUE_APP_API_KEY}`, {
  latLng,
});

//! PUBLIC
const getPublicSite = async (siteId, siteLongId, recaptchaToken) => getRequest(`/public/site/${encodeURIComponent(siteId)}/${encodeURIComponent(siteLongId)}?recaptchaToken=${encodeURIComponent(recaptchaToken)}&code=${VUE_APP_API_KEY}`, false);
const publicSignIn = async (siteId, siteLongId, latLng, name, company, emailAddress, visiting, phoneNumber, responses, recaptchaToken) => postRequest(`/public/site/${encodeURIComponent(siteId)}/${encodeURIComponent(siteLongId)}/sign-in?code=${VUE_APP_API_KEY}`, {
  latLng,
  responses,
  emailAddress,
  name,
  company,
  phoneNumber,
  visiting,
  recaptchaToken,
}, false);
const publicSignOut = async (siteId, siteLongId, signInLongId, latLng, name, company, emailAddress, visiting, phoneNumber) => postRequest(`/public/site/${encodeURIComponent(siteId)}/${encodeURIComponent(siteLongId)}/sign-out?code=${VUE_APP_API_KEY}`, {
  latLng,
  emailAddress,
  name,
  company,
  phoneNumber,
  visiting,
  signInLongId,
}, false);

/* eslint-disable import/prefer-default-export */
export {
  getUsers,
  getMyUser,
  getSites,
  getActiveSites,
  getSite,
  addSite,
  updateSite,
  getSignIns,
  getPublicSignIns,
  signIn,
  signOut,
  getPublicSite,
  publicSignIn,
  publicSignOut,
  deleteSite,
  activateSite,
};
